import store from "@/store/store";

export const roleGuard = (to: any, from: any, next: any) => {
  if (!store.getters.getRole) {
    next({ path: "/" });
  } else next();
};
